import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import clsx from 'clsx';
const Overlay = ({ children, customClassName = '', inlineStyles = {}, onClickOverlay = () => { } }) => {
    const classes = useStyles();
    const containerStyle = clsx({
        [classes.container]: true,
        [customClassName]: Boolean(customClassName)
    });
    const jsx = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: containerStyle, style: inlineStyles, onClick: onClickOverlay }),
        children));
    return jsx;
};
Overlay.propTypes = {
    children: PropTypes.node,
    onClickOverlay: PropTypes.func,
    open: PropTypes.bool,
    animationConfig: PropTypes.shape({
        to: PropTypes.object.isRequired,
        config: PropTypes.object
    }),
    node: PropTypes.string,
    customClassName: PropTypes.string,
    inlineStyles: PropTypes.object
};
export { Overlay };
//# sourceMappingURL=Overlay.js.map